import {BasicEntity} from '../../framework/message/BasicEntity';
import {Role} from './Role';
import {TranslatedEmb} from '../../locale/message/TranslatedEmb';

export class Profile extends BasicEntity {
code: string;
description: TranslatedEmb;
label: TranslatedEmb;
perimeter: string;
roles: Role[];
tags: Object;
visionCode: string;
}

